module.exports = __webpack_public_path__ + "img/img_nav_cooperate_hover.c96f6aab.svg";